import React from 'react';
import { motion } from 'framer-motion';
export function MirrorSection() {
  return <section className="pt-8 pb-24 px-4 sm:px-6 lg:px-8 bg-cream-secondary" data-id="element-38">
      <div className="max-w-3xl mx-auto" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="relative" data-id="element-40">
          {/* Decorative quote mark */}
          <div className="absolute -top-10 -left-6 text-8xl text-gold-light opacity-30 font-heading leading-none" aria-hidden="true" data-id="element-41">
            "
          </div>

          <div className="pl-6 sm:pl-8 border-l-2 border-gold/40 space-y-8 text-lg sm:text-xl text-text-dark leading-[1.8]" data-id="element-42">
            <p data-id="element-43">
              Estás en la cama, la casa al fin está en silencio. Deberías estar
              descansando, pero no puedes.
            </p>

            <p data-id="element-44">
              En tu mente se repite, como una película de terror, la escena de
              esta tarde.{' '}
              <span className="font-heading italic text-2xl text-text-medium" data-id="element-45">
                Vuelves a ver su carita asustada.
              </span>{' '}
              Vuelves a escuchar tus propias palabras, hirientes y fuera de
              control.
            </p>

            <p data-id="element-46">
              Te prometiste que hoy sería diferente, pero el cansancio te ganó,
              el desorden te superó y volviste a explotar.
            </p>

            <p className="font-medium" data-id="element-47">
              Ese nudo en tu estómago se llama{' '}
              <span className="text-gold-dark font-bold text-2xl" data-id="element-48">
                Resaca de Culpa
              </span>
              .
            </p>

            <p className="font-heading italic text-2xl text-text-medium" data-id="element-49">
              Y duele más que cualquier berrinche de tu hijo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}